<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="height-100px row p-0 m-0 background-primary-blue w-100 border-bottom border-dark-subtle p-3 z-max d-flex justify-content-center align-items-center">
        <div (click)="back()" class="col-2 pt-4 pb-4 btn text-reset d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-chevron-left fa-xl p-3"></i>
        </div>
        <div class="col-8">
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-auto fs-main text-center color-white">Animals ({{ allAnimals().length }})</div>
            </div>
            <div class="row d-flex justify-content-center align-items-center">
                @if (unknown > 0) {
                    <div (click)="filterByAnimalType([AnimalType.UNKNOWN], true)"
                        class="col-auto p-1 pointer">
                        <app-animal-svg
                                [animalType]="AnimalType.UNKNOWN"
                                [height]="'20px'"
                                [width]="'20px'"
                                class="img-fluid img-max m-auto"></app-animal-svg>
                        <span class="m-1 color-white"> {{ unknown }} </span>
                    </div>
                }
                @if (cows > 0) {
                    <div (click)="filterByAnimalType([AnimalType.COW], true)"
                        class="col-auto p-1 pointer">
                        <app-animal-svg
                                [animalType]="AnimalType.COW"
                                [height]="'20px'"
                                [width]="'20px'"
                                class="img-fluid img-max m-auto"></app-animal-svg>
                        <span class="m-1 color-white"> {{ cows }} </span>
                    </div>
                }
                @if (bulls > 0) {
                    <div (click)="filterByAnimalType([AnimalType.BULL], true)"
                        class="col-auto p-1 pointer">
                        <app-animal-svg
                                [animalType]="AnimalType.BULL"
                                [height]="'20px'"
                                [width]="'20px'"
                                class="img-fluid img-max m-auto"></app-animal-svg>
                        <span class="m-1 color-white"> {{ bulls }} </span>
                    </div>
                }
                @if (calves > 0) {
                    <div (click)="filterByAnimalType([AnimalType.BULL_CALF, AnimalType.STEER_WEANER, AnimalType.HEIFER_WEANER, AnimalType.HEIFER_CALF, AnimalType.STEER_CALF], true)"
                        class="col-auto p-1 pointer">
                        <app-animal-svg
                                [animalType]="AnimalType.HEIFER_WEANER"
                                [height]="'20px'"
                                [width]="'20px'"
                                class="img-fluid img-max m-auto"></app-animal-svg>
                        <span class="m-1 color-white"> {{ calves }} </span>
                    </div>
                }
                @if (steers > 0) {
                    <div (click)="filterByAnimalType([AnimalType.STEER], true)"
                        class="col-auto p-1 pointer">
                        <app-animal-svg
                                [animalType]="AnimalType.STEER"
                                [height]="'20px'"
                                [width]="'20px'"
                                class="img-fluid img-max m-auto"></app-animal-svg>
                        <span class="m-1 color-white"> {{ steers }} </span>
                    </div>
                }
                @if (numberOfAnimalsOutOfBounds > 0) {
                    <div (click)="filterByAlertStatus([AlertStatus.OUT_OF_PADDOCK, AlertStatus.OUT_OF_FARM], true)"
                        class="col-auto p-1 pointer">
                        <span><app-oop-svg
                            [height]="'20px'"
                            [width]="'20px'"
                            class="img-fluid img-max m-auto"></app-oop-svg></span>
                        <span class="color-white p-1">{{ numberOfAnimalsOutOfBounds }}</span>
                    </div>
                }
                @if (numberOfAnimalsThatStoppedMoving > 0) {
                    <div (click)="filterByAlertStatus([AlertStatus.STOPPED_MOVING], true)"
                        class="col-auto p-1 pointer">
                        <span><app-stopped-moving-svg
                            [height]="'20px'"
                            [width]="'20px'"
                            class="pointer img-fluid img-max m-auto"></app-stopped-moving-svg></span>
                        <span class="color-white p-1">{{ numberOfAnimalsThatStoppedMoving }}</span>
                    </div>
                }
                @if (numberOfAnimalsWithLowActivity > 0) {
                    <div (click)="filterByAlertStatus([AlertStatus.ABNORMALLY_LOW_ACTIVITY], true)"
                        class="col-auto p-1 pointer">
                        <span><app-abnormal-activity-svg
                            [height]="'20px'"
                            [width]="'20px'"
                            class="pointer img-fluid img-max m-auto"></app-abnormal-activity-svg></span>
                        <span class="color-white p-1">{{ numberOfAnimalsWithLowActivity }}</span>
                    </div>
                }
                @if (numberOfAnimalsWithHighActivity > 0) {
                    <div (click)="filterByAlertStatus([AlertStatus.ABNORMALLY_HIGH_ACTIVITY], true)"
                        class="col-auto p-1 pointer">
                        <span><app-abnormal-activity-svg
                            [height]="'20px'"
                            [width]="'20px'"
                            [high]="true"
                            class="pointer img-fluid img-max m-auto"></app-abnormal-activity-svg></span>
                        <span class="color-white p-1">{{ numberOfAnimalsWithHighActivity }}</span>
                    </div>
                }
            </div>
        </div>
        <div (click)="close()" class="pointer text-reset col-2 d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-x fa-xl"></i>
        </div>
    </div>
    <div class="d-flex flex-column p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        <div>
            <div class="mb-3">
                <div class="input-group position-relative">
                    <input (input)="filterResults(getInput($event.target))"
                           class="form-control m-auto rounded-pill height-50px ps-3 pe-3"
                           placeholder="Search..."
                           style="padding-right: 30px;"
                           type="search">
                    <i class="fa-solid fa-magnifying-glass"
                       style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); pointer-events: none;"></i>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-6">
                    <app-generic-button
                        (click)="openAddAnimalComponent()"
                        [disabled]="!userStore.canEdit()"
                        description="Add animal"
                        [alwaysShowText]="true"
                        [buttonText]="'Add animal'"
                        [primaryIcon]="'fa-solid fa-plus'"/>
                </div>
                <div class="col-6">
                    <app-generic-button
                        (click)="openCloseFilters()"
                        description="Show or hide filters"
                        [alwaysShowText]="true"
                        [buttonText]="'Filters'"
                        [primaryIcon]="'fa-solid fa-filter'"/>
                </div>
            </div>
            @if (filtersOpen) {
                <div class="mb-2">
                    <div class="dropdown">
                        <button aria-controls="paddockDropdown"
                                aria-expanded="false"
                                class="btn btn-info btn-info-shadow dropdown-toggle w-100"
                                data-bs-target="#paddockDropdown"
                                data-bs-toggle="collapse"
                                type="button">
                            {{ paddockStore.selectedPaddock()?.name || "Filter by paddock" | toCapitalizedText }}
                        </button>
                        <div class="collapse w-100" id="paddockDropdown">
                            <div (click)="selectPaddock()"
                                class="btn card"
                                data-bs-target="#paddockDropdown"
                                data-bs-toggle="collapse">All</div>
                            @for (paddock of allPaddocks; track paddock.id) {
                                <div (click)="selectPaddock(paddock)"
                                    data-bs-target="#paddockDropdown"
                                    data-bs-toggle="collapse"
                                    class="btn card">{{ paddock.name | toCapitalizedText }}
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="mb-2">
                    <div class="dropdown">
                        <button aria-controls="animalTypeDropdown"
                                aria-expanded="false"
                                class="btn btn-info btn-info-shadow dropdown-toggle w-100"
                                data-bs-target="#animalTypeDropdown"
                                data-bs-toggle="collapse"
                                type="button">
                            {{ (selectedAnimalTypes | toCapitalizedText) || "Filter by type" }}
                        </button>
                        <div class="collapse w-100" id="animalTypeDropdown">
                            <div (click)="filterByAnimalType([])"
                                class="btn card"
                                data-bs-target="#animalTypeDropdown"
                                data-bs-toggle="collapse">All</div>
                            @for (animalType of allAnimalTypes; track animalType) {
                                <div (click)="filterByAnimalType([animalType])"
                                    data-bs-target="#animalTypeDropdown"
                                    data-bs-toggle="collapse"
                                    class="btn card">{{ animalType | toCapitalizedText }}
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="mb-2">
                    <div class="dropdown">
                        <button aria-controls="statusDropdown"
                                aria-expanded="false"
                                class="btn btn-info btn-info-shadow dropdown-toggle w-100"
                                data-bs-target="#statusDropdown"
                                data-bs-toggle="collapse">
                                @if (selectedAlertStatuses.size > 0) {
                                    {{ selectedAlertStatuses | toCapitalizedText }}
                                } @else {
                                    Filter by alert status
                                }
                        </button>
                        <div class="collapse w-100" id="statusDropdown">
                            <div (click)="filterByAlertStatus([])"
                                data-bs-target="#statusDropdown"
                                data-bs-toggle="collapse"
                                class="btn card">All</div>
                            @for (status of [AlertStatus.OUT_OF_PADDOCK, AlertStatus.OUT_OF_FARM, AlertStatus.STOPPED_MOVING, AlertStatus.ABNORMALLY_LOW_ACTIVITY, AlertStatus.ABNORMALLY_HIGH_ACTIVITY]; track status) {
                                <div (click)="filterByAlertStatus([status])"
                                    data-bs-target="#statusDropdown"
                                    data-bs-toggle="collapse"
                                    class="btn card">{{ status | toCapitalizedText }}
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="mb-2">
                    <div class="dropdown">
                        <button aria-controls="lastSeenDropdown"
                                aria-expanded="false"
                                class="btn btn-info btn-info-shadow dropdown-toggle w-100"
                                data-bs-target="#lastSeenDropdown"
                                data-bs-toggle="collapse">
                            {{ selectedLastSeenPeriod || "Filter by last seen" | toCapitalizedText }}
                        </button>
                        <div class="collapse w-100" id="lastSeenDropdown">
                            <div (click)="filterByLastSeenPeriod()"
                                class="btn card"
                                data-bs-target="#lastSeenDropdown"
                                data-bs-toggle="collapse">All</div>
                            @for (period of [LastSeenPeriod.LAST_4_HOURS, LastSeenPeriod.LAST_24_HOURS, LastSeenPeriod.LAST_3_DAYS, LastSeenPeriod.LAST_7_DAYS, LastSeenPeriod.LAST_30_DAYS]; track period) {
                                <div (click)="filterByLastSeenPeriod(period)"
                                    data-bs-target="#lastSeenDropdown"
                                    data-bs-toggle="collapse"
                                    class="btn card">{{ period | toCapitalizedText }}
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="mb-2">
                    <div class="dropdown">
                        <button aria-controls="sortDropdown"
                                aria-expanded="false"
                                class="btn btn-info btn-info-shadow dropdown-toggle w-100"
                                data-bs-target="#sortDropdown"
                                data-bs-toggle="collapse">
                            {{ selectedSortMessage || "Sort" | toCapitalizedText }}
                        </button>
                        <div class="collapse w-100" id="sortDropdown">
                            <div (click)="sortBy()"
                                class="btn card"
                                data-bs-target="#sortDropdown"
                                data-bs-toggle="collapse">Unsorted</div>
                            @for (option of [SortOption.NAME_ASCENDING, SortOption.NAME_DESCENDING, SortOption.LAST_SEEN_DESCENDING, SortOption.LAST_SEEN_ASCENDING]; track option) {
                                <div (click)="sortBy(option)"
                                    data-bs-target="#sortDropdown"
                                    data-bs-toggle="collapse"
                                    class="btn card">{{ option | toCapitalizedText }}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
        <div class="d-flex justify-content-between m-2">
            <div class="form-group">
                <div class="form-check ps-4 pt-1">
                    <input (change)="checkUncheckAllPaddocks()"
                           [checked]="allPaddocksSelected"
                           [disabled]="!networkStatusStore.isOnline() || (!animalsCanBeAltered && !animalsCanBeDeleted)"
                           class="form-check-input p-2"
                           id="selectAll"
                           type="checkbox"
                           value="">
                    <label class="form-check-label" for="selectAll">Select All</label>
                </div>
            </div>
            <div class="row">
                @if (hasDeletableAnimalsSelected()) {
                    <div (click)="deleteAnimals()" class="col pointer pt-1">
                        <i class="fa-solid fa-trash-can color-danger fa-xl"></i>
                    </div>
                }
                @if (hasAlterableAnimalSelected()) {
                    <div (click)="openEditForm()" class="col pointer pt-1">
                        <i class="fa-solid fa-pen-to-square color-primary-blue fa-xl"></i>
                    </div>
                }
            </div>
        </div>
        <div class="flex-grow-1">
            @if (allPaddocks.length === 0) {
                <div class="text-center p-3 opacity-50">
                    Paddocks loading...
                    <app-spinner [loading]="true"></app-spinner>
                </div>
            }
            @for (paddock of filteredPaddocks; track paddock.id) {
                <app-paddock
                    [animals]="getFilteredAnimalsFor(paddock)"
                    [openPaddocks]="openPaddocks"
                    [paddock]="paddock"/>
            }
        </div>
    </div>
</div>
